import { render } from "./Addcontent.vue?vue&type=template&id=369bbc06"
import script from "./Addcontent.vue?vue&type=script&lang=js"
export * from "./Addcontent.vue?vue&type=script&lang=js"

import "./Addcontent.vue?vue&type=style&index=0&id=369bbc06&lang=css"

import exportComponent from "D:\\Shivani\\myProjects\\p2p_admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__